// extracted by mini-css-extract-plugin
export var Center = "microVideo-module--Center--f1a96";
export var Left = "microVideo-module--Left--3a54a";
export var video = "microVideo-module--video--fa8e5";
export var videoContainer = "microVideo-module--videoContainer--1795a";